import { Controller } from "@hotwired/stimulus";
import { translate } from "../app/helpers/classes/translation";

// Replaces the Vue BrandUpgrade/Offer/Cabin components for step2's
// branded-fares picker. All cabins/offers are rendered server-side
// up-front (see Step2::BrandedFaresComponent); this controller only
// toggles visibility/selection state and recomputes displayed prices --
// the actual submit is a plain form post to SearchController#check,
// same as before.
export default class extends Controller {
  static targets = ["cabinSection", "offerCard", "offerRadio", "offerCta", "offerPrice", "baggageCheckbox", "seatsIncludedField"];

  switchCabin(event) {
    const index = event.currentTarget.dataset.cabinIndex;

    this.cabinSectionTargets.forEach((section) => {
      section.classList.toggle("hidden", section.dataset.cabinIndex !== index);
    });

    event.currentTarget.parentElement.querySelectorAll("button").forEach((button) => {
      const active = button === event.currentTarget;
      button.classList.toggle("border-primary", active);
      button.classList.toggle("bg-primary-light", active);
      button.classList.toggle("text-primary", active);
      button.classList.toggle("border-gray-300", !active);
      button.classList.toggle("text-gray-600", !active);
    });

    const section = this.cabinSectionTargets.find((s) => s.dataset.cabinIndex === index);
    const firstRadio = section?.querySelector('[data-offer-selector-target="offerRadio"]');
    if (firstRadio) {
      firstRadio.checked = true;
      this.applySelection(firstRadio);
    }
  }

  selectOffer(event) {
    this.applySelection(event.currentTarget);
  }

  applySelection(selectedRadio) {
    if (this.hasSeatsIncludedFieldTarget) {
      this.seatsIncludedFieldTarget.value = selectedRadio.dataset.seatsIncluded === "true";
    }

    this.offerCardTargets.forEach((card) => {
      const isSelected = card.dataset.offerUuid === selectedRadio.value;
      card.classList.toggle("border-primary", isSelected);
      card.classList.toggle("border-gray-200", !isSelected);

      const cta = card.querySelector('[data-offer-selector-target="offerCta"]');
      if (cta) {
        cta.classList.toggle("border-primary", isSelected);
        cta.classList.toggle("bg-primary", isSelected);
        cta.classList.toggle("text-white", isSelected);
        cta.classList.toggle("border-gray-300", !isSelected);
        cta.classList.toggle("text-gray-700", !isSelected);
        cta.querySelector("span")?.replaceChildren(document.createTextNode(isSelected ? translate("Vald") : translate("Välj")));
      }

      card.querySelectorAll('[data-offer-selector-target="baggageCheckbox"]').forEach((checkbox) => {
        if (isSelected) {
          checkbox.disabled = false;
        } else {
          checkbox.disabled = true;
          checkbox.checked = false;
        }
      });

      this.updatePrice(card);
    });
  }

  toggleBaggage(event) {
    const card = event.target.closest('[data-offer-selector-target="offerCard"]');
    if (card) this.updatePrice(card);
  }

  updatePrice(card) {
    const priceEl = card.querySelector('[data-offer-selector-target="offerPrice"]');
    if (!priceEl) return;

    const basePrice = parseFloat(priceEl.dataset.basePrice || "0");
    let total = basePrice;

    card.querySelectorAll('[data-offer-selector-target="baggageCheckbox"]:checked:not(:disabled)').forEach((checkbox) => {
      total += parseFloat(checkbox.dataset.price || "0");
    });

    priceEl.textContent = this.formatCurrency(total);
  }

  formatCurrency(amount) {
    return Math.round(amount).toLocaleString("sv-SE") + " kr";
  }

  goBack(event) {
    event.preventDefault();
    if (window.gon && window.gon.links && window.gon.links.step_1_url) {
      window.location.href = window.gon.links.step_1_url;
    } else {
      window.history.back();
    }
  }
}
